/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_CURRENT_EXAM_LIST(state, payload) {
    state.currentExamList = payload
  },
  SET_WRITING_EXAM_LIST(state, payload) {
    state.writingExamList = payload
  },
  SET_SCHEDULE_EXAM_LIST(state, payload) {
    state.scheduleExamList = payload
  },
  SET_TEST_EXAM_LIST(state, payload) {
    state.testExamList = payload
  },
  SET_PRACTICE_EXAM_LIST(state, payload) {
    state.practiceExamList = payload
  },
  SET_PRACTICE_RESEARCH_EXAM_LIST(state, payload) {
    var society = payload.filter((item) => {
      return item.subject_detail_type_id < 10
    })
    var science = payload.filter((item) => {
      return item.subject_detail_type_id >= 10
    })
    if(state.practiceExamList[0].subject_type_id == 4){
      for(var i in society){
        state.practiceExamList.push(society[i])
      }
    }else{
      for(var j in science){
        state.practiceExamList.push(science[j])
      }
    }
  },
  SET_PRACTICE_EXAM_STATE(state, payload){
    const index = state.practiceExamList.findIndex((item) => item.id == payload.id)
    state.practiceExamList[index].type_state = payload.type_state
  },
  SET_CATEGORY_LIST(state, payload) {
    state.categoryList = payload
  },
  SET_MAIN_CATEGORY_LIST(state, payload) {
    state.mainCategoryList = payload
  },
  SET_SUB_CATEGORY_LIST(state, payload) {
    state.subCategoryList = payload
  },
  SET_PROGRESS_EXAM(state, payload) {
    state.progressExam = payload
  },
  // UPDATE_ADMIN_TESTING(state, payload) {
  //   const index = state.userExamList.findIndex((item) => item.id == payload.id)
  //   state.testExamList.push(state.userExamList[index])
  //   // state.userExamList[index].test_state = 1
  //   state.userExamList.split(index, 1)
  // },
  SET_QUESTION_TYPE(state, payload) {
    const index = state.questionList.findIndex((item) => item.id == payload.id)
    state.questionList[index].category_id = payload.category_id
    state.questionList[index].main_category_id = payload.main_category_id
    state.questionList[index].sub_category_id = payload.sub_category_id
    state.questionList[index].level = payload.level
  },
  SET_EXAM_TIME_EDITOR(state, payload) {
    state.popUpState = payload
  },
  SET_ALL_EXAM_LIST(state , payload) {
    for(var i=0; i< payload.length; i++) {
      var highSchool = payload.filter((item)=>{
        return item.info == "high"
      })
      state.schoolInfo.first = highSchool.filter((item)=>{
        return item.grade == 1 && item.admin_check >= 1
      })
      state.schoolInfo.second = highSchool.filter((item)=>{
        return item.grade == 2 && item.admin_check >= 1
      })
    }
    state.allExamList = payload
  },
  EXAM_DATE_ID_LIST(state, payload) {
    console.log(payload)
    state.examId = payload.sort((a , b)=> {
      return a.date < b.date ? 1 : -1
    })
  },
  WEEK_LIST_INFO(state, payload) {
    state.weekList = payload
  },
  SET_ADMIN_EXAM_LIST(state, payload) {
    var temp = payload.sort(function(a, b) {
      return a.id < b.id ? -1 : a.id < b.id ? 1 : 0
    })
    state.adminExamList = []
    state.userExamList = []
    state.testExamList = []
    for (var i in temp) {
      if (temp[i].admin_check == 1) {
        temp[i].test_state = 2
        state.adminExamList.push(temp[i])
      }
      else if (temp[i].admin_check == 0) {
        if (temp[i].test_state == 1){
          state.testExamList.push(temp[i])
        } else{
           state.userExamList.push(temp[i])
        }
      }
    }
    // state.adminExamList = payload
  },
  SET_SUBJECT_LIST(state, payload) {
    state.subjectList = payload
  },
  SET_ACTIVE_SUBJECT_ID(state , payload) {
    state.activeSubjectId = payload
  },
  SET_QUESTION_LIST(state, payload) {
    state.questionList = payload.sort(function(a, b) {
      return a.id < b.id ? -1 : a.id > b.id ? 1 : 0
    })
    // state.activeQuestion = payload[payload.length - 1]
  },
  SET_MULTIPLE_QUESTION_LIST(state, payload) {
    state.multipleQuestionList = payload.sort(function(a, b) {
      return a.id < b.id ? -1 : a.id < b.id ? 1 : 0
    })
  },
  CREATE_EXAM(state, payload) {
    state.writingExamList.push(payload)
    state.activeExam = payload
  },
  CREATE_SUBJECT(state, payload) {
    state.subjectList.push(payload)
  },
  CREATE_QUESTION(state, payload) {
    state.questionList.push(payload)
  },
  CREATE_MULTIPLE(state, payload) {
    state.multipleQuestionList.push(payload)
  },
  ACTIVE_EXAML(state, exam) {
    state.activeExam = exam
    state.activeSubject = ''
    state.subjectList = []
    state.activeQuestion = ''
    state.questionList = []
  },
  ACTIVE_SUBJECT(state, subject) {
    state.activeSubject = subject
    state.activeQuestion = ''
    state.questionList = []
  },
  ACTIVE_QUESTION(state, question) {
    state.activeQuestion = question
    state.multipleQuestionList = []
  },
  UPDATE_SUBJECT(state, payload) {
    const index = state.subjectList.findIndex((item) => item.id == payload.id)
    state.subjectList[index] = payload
  },
  UPDATE_QUESTION(state, payload) {
    const index = state.questionList.findIndex((item) => item.id == payload.id)
    state.questionList[index] = payload
  },
  DELETE_QUESTION(state, payload) {
    const index = state.questionList.findIndex((item) => item.id == payload)
    if (index != -1) {
      state.questionList.splice(index, 1)
      if (state.questionList.length == 0) {
        state.activeQuestion = {
          id: -1
        }
      } else if (state.questionList.length == index) {
        state.activeQuestion = state.questionList[index - 1]
      } else {
        state.activeQuestion = state.questionList[index]
      }
      state.multipleQuestionList = []
      // state.activeQuestion = ''
    }
  },
  DELETE_MULTIPLE(state, payload) {
    const index = state.multipleQuestionList.findIndex((item) => item.id == payload)
    if (index != -1) {
      state.multipleQuestionList.splice(index, 1)
    }
  },
  UPDATE_MULTIPLE(state, payload) {
    const index = state.multipleQuestionList.findIndex((item) => item.id == payload.id)
    if (index != -1) {
      state.multipleQuestionList[index].data = payload.data
    }
  },
  SET_ANSWER(state, payload) {
    state.activeQuestion.answer = payload.answer
    state.activeQuestion.ex_answer = payload.ex_answer
  },
  SET_ANSWER_MULTIPLE(state, payload) {
    state.activeQuestion.answer_multiple = payload
  },
  SET_ANSWER_NUMBER(state, payload) {
    state.activeQuestion.answer_number = payload
  },
  SET_DEFECT_EXAM_LIST(state, payload) {
    state.defectExamList = payload
  },
  DELETE_DEFECT_QUESTION(state, payload) {
    const index = state.questionList.findIndex((item) => item.id == payload.id)
    if (index != -1) {
      state.questionList.splice(index, 1)
    }
  },
  UPDATE_QUESTION_COMMAND(state, payload) {
    const index = state.questionList.findIndex((item) => item.id == payload.id)
    if (index != -1) {
      state.questionList[index].command = payload.command
    }
  },
  SET_SUBJECT_TYPE_LIST(state, payload) {
    state.subjectType = payload
  },
  SET_SUBJECT_CODE_LIST(state, payload) {
    state.subjectCode = payload
  },
  SET_SUBJECT_DETAIL_TYPE_LIST(state, payload) {
    state.subjectDetailType = payload
  },
  NEXT_EXAM_LIST_INFO(state,payload) {
    state.nextExamList = payload
  },
  PLANNED_EXAM_LIST(state,payload) {
    state.plannedExamList = payload
  },
  UPDATE_KEYWORD(state, filterName) {
    state.keyWord = filterName
  },
  SET_COLLEGE_INFO(state, payload) {
    state.activeCollege = payload
  },
  UPDATE_TEACHER_ID(state, payload) {
    var index = state.practiceExamList.findIndex((item) => {
      return item.exam_id == payload.exam_id
    })
    if(index != -1){
      console.log('-1')
      state.practiceExamList[index].teacher_id = payload.teacher_id
    }
  },
  SET_ACTIVE_MAJOR_INFO(state, payload) {
    var list = state.majorList.filter((item)=> {
      return item.id == payload
    })
    state.activeMajor = list
  },
  SET_ACTIVE_SCORE_LIST(state , payload) {
    state.scoreList = state.admissionList.filter((item)=> {
      return item.school_id == payload
    })
  },
  GET_UNIV_LIST(state, payload) {
    state.univList = payload
  },
  SAVE_UNIV_INFO(state, payload) {
    state.univInfo = payload
  },
  GET_MAJOR_LIST(state, payload) {
    // for(var i in payload) {
      state.majorList = payload
    // }
  },
  SET_MAJOR_GRD_LIST(state, payload) {
    state.grdList = payload
  },
  SET_MAJOR_GRD_DETAIL(state, payload) {
    state.grdDetail = payload
  },
  ADD_MAJOR_ITEM(state, payload) {
    state.majorList.push(payload)
  },
  DEL_MAJOR_ITEM(state, payload) {
    const eventIndex = state.majorList.findIndex((item) => item.id == payload)
    state.majorList.splice(eventIndex, 1)
  },
  ADD_MAJOR_GRD(state, payload){
    state.grdList.push(payload)
  },
  SET_UNIV_IMAGE(state, payload) {
    state.univImg = payload
  },
}
